// Collapses Adyen's scheme code + reason code into a single short display
// string. Examples: "visa 13.3", "mc 4834", "amex C18". The scheme prefix is
// normalized so Adyen's variants (e.g. "Mc", "Mastercard", "American Express")
// all render consistently.
const SCHEME_PREFIXES = {
    'visa': 'visa',
    'mc': 'mc',
    'mastercard': 'mc',
    'amex': 'amex',
    'american express': 'amex',
    'americanexpress': 'amex',
    'discover': 'discover'
};
const schemePrefix = (scheme) => {
    const normalized = scheme.trim().toLowerCase();
    return SCHEME_PREFIXES[normalized] ?? normalized;
};
export const formatReasonCode = (scheme, code) => {
    const trimmedCode = code?.trim();
    if (!trimmedCode) {
        return '';
    }
    const trimmedScheme = scheme?.trim();
    if (!trimmedScheme) {
        return trimmedCode;
    }
    return `${schemePrefix(trimmedScheme)} ${trimmedCode}`;
};
// Operator-facing (brand-cased) label variants used in headers. Adyen ships
// lowercase enum values; map to the display forms operators recognize
// ("Amex C18", "MC 4834", "Visa 13.1"). Falls back to uppercase for unknown
// schemes so nothing silently disappears.
const SCHEME_LABEL = {
    'visa': 'Visa',
    'mastercard': 'MC',
    'mc': 'MC',
    'amex': 'Amex',
    'americanexpress': 'Amex',
    'american express': 'Amex',
    'discover': 'Discover'
};
export const formatSchemeReasonLabel = (scheme, code) => {
    const schemeRaw = scheme?.trim();
    const label = schemeRaw
        ? SCHEME_LABEL[schemeRaw.toLowerCase()] ?? schemeRaw.toUpperCase()
        : undefined;
    const trimmedCode = code?.trim();
    if (label && trimmedCode) {
        return `${label} ${trimmedCode}`;
    }
    if (label) {
        return label;
    }
    return trimmedCode ?? '';
};
